import { createSlice } from "@reduxjs/toolkit";
import { _setTutoringAvailabilityDetails } from "./tutoringAvailabilityAction";
import initialState from "./tutoringAvailabilityInitialState";

const tutoringAvailabilitySlice = createSlice({
  name: "deltaSnp/tutoringAvailability",
  initialState: null,
  reducers: {
    setTutoringAvailabilityDetails: _setTutoringAvailabilityDetails,
    resetTutoringAvailabilityDetails: () => initialState,
  },
});

export const {
  setTutoringAvailabilityDetails,
  resetTutoringAvailabilityDetails,
} = tutoringAvailabilitySlice.actions;

export default tutoringAvailabilitySlice.reducer;
